import { Toast } from '@/components/Toast'
import store from '@/store'
import { i18n } from '@/utils/i18n'
import { logEvent } from '@/utils/log'
import axios from 'axios'

// 创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL, // 基础请求地址，可根据环境变量配置
  timeout: 60000, // 请求超时时间，单位毫秒
  withCredentials: false,
  headers: {
    platform: /iPad|iPhone|iPod/.test(navigator.userAgent) ? 'IOS' : 'ANDROID',
    p: 10001
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log(config)
    config.headers['currentLanguage'] = store.state.common.lang
    try {
      const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      if (userInfo?.token) {
        config.headers['TOKEN'] = userInfo.token
      }
    } catch (e) {
      console.error(e)
    }

    return config
  },
  error => {
    // 请求错误处理
    return Promise.reject(error)
  }
)

let loginCount = 0
// 响应拦截器
service.interceptors.response.use(
  async response => {
    let res = response.data
    if (res?.status === 6 && loginCount < 3 && response.config.url !== '/user/login') {
      loginCount++
      await store.dispatch('common/logout')
      await store.dispatch('common/login')
      // 登录成功，重试本请求
      res = await service.request(response.config)
      console.log("login again")
      return res
    } else if (res?.status) {
      logEvent({
        event: 'request_fail',
        map: {
          status: res?.status,
          msg: res?.message,
          url: response.config.url,
        }
      })
    }

    return res
  },
  error => {
    // 响应错误处理
    console.log("axios error", error.status, error.statusCode)
    Toast(i18n.t('netErr'))
    logEvent({
      event: 'request_error',
      map: {
        error: JSON.stringify(error)
      }
    })
    return Promise.reject(error)
  }
)

export default service
